// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1txhH","info":"Note_info__LXqqE","note":"Note_note__2dfYL","actions":"Note_actions__2ZHsS"};